if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then(response => response.text())
          .then(responseText => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);

            // Inicializar checkbox de regalo usando función global
            this.initQuickAddGift();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      initQuickAddGift() {
        const giftCheckbox = this.modalContent.querySelector('#gift-checkbox');
        if (!giftCheckbox || giftCheckbox.dataset.giftInit) return;
        giftCheckbox.dataset.giftInit = 'true';

        giftCheckbox.addEventListener('change', () => {
          console.log('[GiftDebug][QuickAdd] Checkbox cambiado:', giftCheckbox.checked, '→ Variant ID:', giftCheckbox.value);
        });

        const addButton = this.modalContent.querySelector('form[action*="/cart/add"] button[type="submit"]');
        if (!addButton) return;

        addButton.addEventListener('click', async () => {
          const giftId = giftCheckbox.checked ? Number(giftCheckbox.value) : null;
          if (!giftId) return;

          // Esperamos a que el producto principal se agregue (polling simplificado)
          const initialCart = await fetch('/cart.js').then(r => r.json());
          const initialCount = initialCart.items.length;

          const waitForProduct = async (tries = 0) => {
            const cart = await fetch('/cart.js').then(r => r.json());
            if (cart.items.length > initialCount) {
              console.log('[GiftDebug][QuickAdd] Producto principal detectado, agregando regalo', giftId);
              await window.addGiftToCart(giftId);
              giftCheckbox.checked = false;
              return;
            }
            if (tries < 10) setTimeout(() => waitForProduct(tries + 1), 300);
          };

          waitForProduct();
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        this.productElement.querySelectorAll('modal-dialog').forEach(modal => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info')
          .forEach(el => el.dataset.originalSection = sectionId);
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product.classList.contains('product--columns')) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) sizes = sizes.replace('715px','605px');
        else if (product.classList.contains('product--small')) sizes = sizes.replace('715px','495px');

        mediaImages.forEach(img => img.setAttribute('sizes', sizes));
      }
    }
  );
}
